import { Box, Typography } from "@mui/material";
import styles from "../styles";

const DrawDetailHeroComponent = ({ drawData, isImageDark }) => {
  return (
    <Box sx={{ position: "relative" }}>
      <Box sx={styles.pageBgImage} />
      <Box sx={styles.bannerImage}>
        <Box
          component={"img"}
          sx={styles.bannerImageView}
          src={drawData?.bannerImage ? drawData?.bannerImage : ""}
        />
        <Box sx={styles.bannerContent}>
          <Typography
            sx={{
              ...styles.bannerTitle,
              color: isImageDark
                ? "rgba(255, 255, 255, 1)"
                : "rgba(0, 0, 0, 0.9)",
            }}
          >
            Play and Win
          </Typography>
          <Typography
            sx={{
              ...styles.bannerSubTitle,
              color: isImageDark
                ? "rgba(255, 255, 255, 1)"
                : "rgba(0, 0, 0, 0.9)",
            }}
          >
            <br />
            {drawData?.title ? drawData?.title : ""}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default DrawDetailHeroComponent;
